import {isAuth} from "@/assets/utils/auth.utils";
import ReferralsPage from "@/pages/referrals/ReferralsPage.vue";
import ReferralSinglePage from "@/pages/referrals/ReferralSinglePage.vue";
import ReferralTransactionHistory from "@/pages/referrals/ReferralTransactionHistory.vue";

export default [
  {
    name: "referrals",
    path: "/referrals",
    component: ReferralsPage,
    beforeEnter: isAuth,
    meta: {
      permission: "view",
      way: "referrals",
    },
  },
  {
    name: "referral",
    path: "/referral/:id",
    component: ReferralSinglePage,
    beforeEnter: isAuth,
    meta: {
      permission: "edit",
      way: "referrals",
    },
  },
  {
    name: "referral-transaction",
    path: "/referral-transaction/:id",
    component: ReferralTransactionHistory,
    beforeEnter: isAuth,
    meta: {
      permission: "view",
      way: "referrals",
    },
  },
];
